import { className } from '@/components/misc/version/utils'

function renderVersionTitle(h) {
  return h(
    'div',
    {
      class: 'link link--passive',
      on: {
        click: () => {
          return this.copy()
        }
      }
    },
    [ this.getTranslate(`${className}.title`, { version: this.currentVersion }) ]
  )
}

function renderUpdateButton(h) {
  if (this.hasNewVersion) {
    return h(
      'div',
      {
        class: 'link',
        on: {
          click: () => {
            return this.applyAvailableUpdate()
          }
        }
      },
      [ this.getTranslate('misc.buttons.update') ]
    )
  }
}

export default function(h) {
  return h(
    'div',
    { class: className },
    [
      renderVersionTitle.call(this, h),
      renderUpdateButton.call(this, h)
    ]
  )
}
